<card name="Actions">
  <div card content>
    <table-action [addButton]="true"></table-action>
  </div>
</card>
